@if(interactive) {
    <button class="chip-body interactive hover:underline" [class.removable]="removable">
        <ng-container *ngTemplateOutlet="chipContent" />
    </button>
} @else {
    <div class="chip-body cursor-default" [class.removable]="removable">
        <ng-container *ngTemplateOutlet="chipContent" />
    </div>
}

<ng-template #chipContent>
    <div class="font-bold text-sm">
        <ng-content />
    </div>
    @if(removable) {
        <button (click)="remove.emit()" class="-mr-3 group leading-none">
            <i class="fa-regular fa-circle-xmark fa-lg group-hover:font-bold group-active:text-gray-200"></i>
        </button>
    }
</ng-template>